import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GiftLanguageChooserComponent } from './gift-language-chooser.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatToolbarModule } from "@angular/material/toolbar";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { TranslateModule } from "@ngx-translate/core";
import { MatInputModule } from "@angular/material/input";
import { ReactiveFormsModule } from "@angular/forms";
import { TruncateModule } from "@pipes/truncate/truncate.module";
import { TranslateDomainModule}  from "@web/app/pipes/translate/translate-domain.module";
import { MatSelectModule } from '@angular/material/select';
import { WsUiModule } from '@web/util/ws-ui/ws-ui.module';

@NgModule({
  declarations: [GiftLanguageChooserComponent],
  entryComponents: [GiftLanguageChooserComponent],
  imports: [
    CommonModule,
    MatDialogModule,
    MatToolbarModule,
    MatButtonModule,
    MatIconModule,
    MatSelectModule,
    TranslateModule,
    MatInputModule,
    ReactiveFormsModule,
    TruncateModule,
    TranslateDomainModule,
    WsUiModule
  ]
})
export class GiftLanguageChooserModule { }
